const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  'application/pdf': 'PDF',
  'text/csv': 'CSV',
  'application/json': 'JSON',
  'text/markdown': 'Markdown',
  'text/plain': 'Text file',
  'text/html': 'HTML',
};

export function getDocumentTypeLabel(mimeType: string): string {
  return DOCUMENT_TYPE_LABELS[mimeType] ?? 'File';
}
